import { render, staticRenderFns } from "./ScheduleForDelivery.vue?vue&type=template&id=73832077&scoped=true&"
import script from "./ScheduleForDelivery.vue?vue&type=script&lang=js&"
export * from "./ScheduleForDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73832077",
  null
  
)

export default component.exports